export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  // [xleaders] XO-10
  ZALO_PERSONAL_DISCONNECTED: ['i-lucide-unplug', 'text-n-ruby-11'],
};

// [xleaders] XO-10: thông báo Zalo rớt trỏ tới hội thoại gần nhất của inbox, kèm cờ để dải cảnh báo
// của XO-09 tự bật hộp thoại QR. Inbox chưa có hội thoại thì về danh sách của inbox.
export const ZALO_PERSONAL_ACTOR = 'Channel::ZaloPersonal';

export const zaloRescanRoute = (inboxId, conversationId) => {
  if (!conversationId) {
    return { name: 'inbox_dashboard', params: { inbox_id: inboxId } };
  }
  return {
    name: 'inbox_conversation',
    params: { conversation_id: conversationId },
    query: { zalo_rescan: 1 },
  };
};
